
import { mapActions, mapGetters } from 'vuex'
import store from '@/common/config/store'

export default {
  
  components: {
    'component-placeholder': () => import(/* webpackChunkName: "components" */ '@/common/components/Placeholder.vue')
  },
  
  data: () => ({
    store
  }),
  
  computed: {
    hasResult () {
      return this.beneficiaryLists.length
    },
    
    ...mapGetters([
      'beneficiaryLists'
    ])
    
  },
  
  watch: {
    'store.data.user.account.uuid': function () {
      this.getBeneficiaryLists()
      this.getBeneficiaryListTypes()
    }
  },
  
  mounted () {
    this.getBeneficiaryLists()
    this.getBeneficiaryListTypes()

    this.$bus.$on('delete-success', this.onListDeleted)
  },
  
  destroyed () {
    this.$bus.$off('delete-success', this.onListDeleted)
  },
  
  methods: {
    ...mapActions([
     'getBeneficiaryLists',
     'getBeneficiaryListTypes'
    ]),
    
    getListComment (list) {
      return list.comment || '-'
    },
    
    editList (listId = null) {
      this.showModal({
        childVue: 'create-beneficiary-list',
        dataModel: {
          id: listId
        },
        wrapperClass: 'modal--md',
      })
    },
    
    deleteList (listId) {
      this.showModal({
        childVue: 'delete',
        dataModel: {
          url: `${store.api.base}/beneficiary-lists/${listId}`,
          title: this.$i18n.t('modal.delete.beneficiary_list.title'),
          content: this.$i18n.t('modal.delete.beneficiary_list.content')
        }
      })
    },
    
    onListDeleted () {
      this.showBanner('success', this.$i18n.t('banner.success.beneficiary_list.delete'))
      this.getBeneficiaryLists()
    }
  },
}
